import React from "react";

interface LoadingProps {
  data?: {};
}

const OverviewLoaders: React.FC<LoadingProps> = ({ data }) => {
  return (
    <div className="px-3 md:px-6 grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-2  gap-4 mt-3 md:mt-4">
      {[1, 2, 3, 4].map((i) => (
        <div
          key={i}
          className="w-full h-full px-3 pt-3 pb-[10px] md:pb-[20px] bg-[#ffffff] border border-[#EAECF0] rounded-lg"
        >
          <div className="whitespace-nowrap font-medium flex flex-col text-gray-900 animate-pulse px-3 py-[18px]">
            {i == 4 ? (
              <div className="flex justify-between items-center">
                <span className="h-5 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
                <span className="h-5 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
              </div>
            ) : (
              <span className="h-5 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
            )}
            <span
              className={`h-5 bg-[#E6EEF5] inline-block ${i == 4 ? "w-[100%]" : "w-[70%]"} rounded-md mt-3`}
            ></span>
            {i == 4 ? (
              <div className="flex justify-between items-center mt-3">
                <span className="h-5 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
                <span className="h-5 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
              </div>
            ) : (
              <>
                {i < 3 && (
                  <span className="h-5 bg-[#E6EEF5] inline-block w-[10%] rounded-md mt-3"></span>
                )}
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default OverviewLoaders;
